import { toCamelCaseProperties } from '@/utils/fn';
import moment from '@/plugins/moment';

export default class MySalons {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};
		this.chainId = args.chainId || 0;
		this.chainImageUrl = args.chainImageUrl || '';
		this.chainName = args.chainName || '';
		this.customers = (args.customers || []).map(customers => new Customer(customers));
	}
}
export class Customer {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.customerId = args.customerId || "";
        this.firstName = args.firstName || "";
        this.lastName = args.lastName || "";
        this.lastVisitDate = moment(args.lastVisitDate || '');
		this.lastVisitSiteId = args.lastVisitSiteId || '';
	}
}

